﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from '../Modal/GlobalDialog';
import { Entities } from '../../models/enums';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';

import { Button } from 'devextreme-react/button';

let key = 1;

export default function PrintBenchSheetForm() {
    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    const parts = window.location.href.split('/');
    const benchSheetId = parts[parts.length - 1];

    key++;

    return (
        <div className="pw-form-container">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Print Bench Sheet</div>
                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                   
                    {/*
                    <div>
                        <NavLink to={`/documentation/${DocumentationConstants.ColumnsForm}`}
                            className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                            <Button className="title-bar-button pw-orange"
                                text="" icon="help" type="normal"
                                hint="help and documentation" />
                        </NavLink>
                    </div>
                    */}

                </div>
            </div>

             <div className='pw-comp-row pw-margin-top-1'>
                    <Button type='success' text='Print Bench Sheet Report' icon="print"
                    height='2.6em' 
                        onClick={onRunReportClick} />
                </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    //need Bench Sheet Raw Material Batch name etc.  ???
    //may need to move ReportId to the Entities table (not forms)

    //based on bench sheet id, then need to get ReportId
    /*
    async function getPrintReportId() {
        if (reportId) {
            await CrudFunctions.getData(`aaaa/${reportId}`)
                .then(data => {
                   setReportId(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Report ID");
                });
        }
    }
    */

    async function getAllData() {
        //await getPrintReportId();

    }

    async function onRunReportClick() {
        if (benchSheetId) {
            await CrudFunctions.getDataBlob(`reporting/generatebenchsheetreport/${benchSheetId}`)
                .then((blob: any) => {
                    let a = document.createElement("a") as HTMLAnchorElement;

                    document.body.appendChild(a);
                    a.style.display = "none";

                    var url = window.URL.createObjectURL(blob);
                    a.href = url;

                    //todo:
                    a.download = `COA-${benchSheetId}.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(url);

                    //to open PDF in browser:
                    // let file = window.URL.createObjectURL(blob);
                    // window.open(file, "_blank");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Printing Bench Sheet Report");
                });
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
 
    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}
